import * as geometryEngineAsync from '@arcgis/core/geometry/geometryEngineAsync';
import { useCallback, useEffect, useState } from 'react';

// Selector state.
const useSelector = (): any[] => {
    const [selectorInfo, setSelectorInfo] = useState<any>(null);
    const [selector, setSelector] = useState<any>(null);

    useEffect(() => {
        const updateSelectorInfo = async () => {
            const tool = selector.tool;
            const geometry = selector.geometry;
            const label = selector.label ?? (await getLabel(tool, geometry));
            setSelectorInfo({ tool, geometry, label });
        };
        if (selector !== null) updateSelectorInfo();
        else setSelectorInfo(null);
    }, [selector]);

    const clearSelector = useCallback(() => {
        setSelector(null);
    }, [setSelector]);

    return [selectorInfo, setSelector, clearSelector];
};
export default useSelector;

const getLabel = async (tool: string, geometry: any): Promise<string> => {
    const center = geometry.extent.center;
    const lat = tool !== 'polyline' ? toNumber(round(center.latitude, 2)) : '';
    const lng = tool !== 'polyline' ? toNumber(round(center.longitude, 2)) : '';
    const kmsqArea = await geometryEngineAsync.geodesicArea(
        geometry,
        'square-kilometers'
    );
    const area = tool !== 'polyline' ? toNumber(round(kmsqArea, 2)) : '';
    const radius =
        tool === 'circle'
            ? toNumber(round(Math.sqrt(kmsqArea / Math.PI), 2))
            : '';
    const kmsqLength = await geometryEngineAsync.geodesicLength(
        geometry,
        'kilometers'
    );
    const length = tool === 'polyline' ? toNumber(round(kmsqLength, 2)) : '';
    const arrLabel = [tool.charAt(0).toUpperCase() + tool.slice(1)];
    if (lat !== '') arrLabel.push(`(${lat}°N, ${lng}°E)`);
    if (area !== '') arrLabel.push(`${area}km²`);
    if (radius !== '') arrLabel.push(`radius: ${radius}km²`);
    if (length !== '') arrLabel.push(`${length}km`);
    return arrLabel.join(', ');
};

const numberFormatter = new Intl.NumberFormat('en-En');

const toNumber = (value: number): string => {
    return numberFormatter.format(value);
};

const round = (value: number, nDecimal: number): number => {
    const n = Math.pow(10, nDecimal);
    return Math.round((value + Number.EPSILON) * n) / n;
};
